import { z } from "zod";
import { TApiObjectBase, TObjectBase } from "../../base";
import { TReadAccess } from "../../common/readAccess";
import { TRelatives } from "../../common/relative";
import { TDocumentAIType, TFileDataFields } from "../../file/file";

const PropertyFileObject = z.object({
  name: z.string(),
  size: z.number().nullish(),
  contentSummary: z.string().nullish(),
  documentType: TDocumentAIType.nullish(),
  path: z.string().nullish(),
  externalURL: z.string().nullish(),
  type: z.string().nullish(),
  folderIDs: z.array(z.string()).nullish(),
  readAccess: TReadAccess.nullish(),
  tags: z
    .object({
      standard: z.array(z.string()).nullish(),
    })
    .nullish(),
  relatives: TRelatives.nullish(),
  dataFields: TFileDataFields.nullish(),
  externalFileClientID: z.string().nullish(),
  externalFileMetadata: z
    .object({
      propertyID: z.string().nullish(),
    })
    .nullish(),
  externalRefs: z
    .record(
      z
        .object({
          id: z.string().nullish(),
        })
        .or(z.string().nullish())
    )
    .nullish(),
  previewPath: z.string().nullish(),
  rawText: z.string().nullish(),
});

export const TRawPropertyFile = z
  .object({})
  .extend(PropertyFileObject.shape)
  .extend(TObjectBase.shape);
export type IRawPropertyFile = z.infer<typeof TRawPropertyFile>;

/**
 * @deprecated Use `TApiFile` instead.
 */
export const TApiPropertyFile = z
  .object({})
  .extend(PropertyFileObject.shape)
  .extend(TApiObjectBase.shape);
/**
 * @deprecated Use `IApiFile` instead.
 */
export type IApiPropertyFile = z.infer<typeof TApiPropertyFile>;
